import { useTailwindBreakpoints } from "components/hooks/use-tailwind-breakpoints"

import { BackgroundImage } from "components/shared/background-img"
import { Box } from "components/shared/box"
import { Text } from "components/shared/text"
import { TitleDivider } from "components/shared/title-divider"

import { BotWithRectangle } from "./bot-with-rectangle"

const bots3dImages = [
  {
    imgSrc: "/images/pages/bot-3d/what-the-bots/blue-bot.png",
    hoveredImgSrc: "/images/pages/bot-3d/what-the-bots/blue-bot-hovered.png",
  },
  {
    imgSrc: "/images/pages/bot-3d/what-the-bots/yellow-bot.png",
    hoveredImgSrc: "/images/pages/bot-3d/what-the-bots/yellow-bot-hovered.png",
  },
  {
    imgSrc: "/images/pages/bot-3d/what-the-bots/violet-bot.png",
    hoveredImgSrc: "/images/pages/bot-3d/what-the-bots/violet-bot-hovered.png",
  },
  {
    imgSrc: "/images/pages/bot-3d/what-the-bots/red-bot.png",
    hoveredImgSrc: "/images/pages/bot-3d/what-the-bots/red-bot-hovered.png",
  },
]

export const WHAT_THE_BOTS_BLOCK_ID = "what-the-bots"

export function WhatTheBots() {
  const { xs } = useTailwindBreakpoints()
  return (
    <div id={WHAT_THE_BOTS_BLOCK_ID} className="overflow-hidden">
      <BackgroundImage imageSrc="/images/pages/bot-3d/what-the-bots/bg.png" className="bg-cover bg-no-repeat bg-bottom">
        <Box className="pt-20 mx-[32px] relative">
          <Box className="sm:w-[700px] lg:ml-auto z-10">
            <Text weight="bold" className={`uppercase text-[48px] leading-[48px] lg:text-[5rem] lg:leading-[5rem]`}>
              meet 3d
            </Text>
            <Text weight="bold" className="uppercase text-[48px] leading-[48px] lg:text-[5rem] lg:leading-[5rem]">
              cryptobots
            </Text>
            <TitleDivider className="mt-6" />
            <Text className="mt-6">3D PFP Collection of up to 10,000 NFTs playable in the Cryptobots Game</Text>
          </Box>

          <Box className="sm:h-0 sm:pb-[min(600px,50%)] mb-12 sm:mb-0">
            <Box row={!xs} className="justify-between sm:absolute top-24 mt-8 sm:mt-0 w-full gap-[40px] sm:gap-0">
              {bots3dImages.map((bot, i) => (
                <BotWithRectangle
                  key={bot.imgSrc}
                  imgSrc={bot.imgSrc}
                  hoveredImgSrc={bot.hoveredImgSrc}
                  showGradient={xs && !!(i % 2)}
                  reversed={xs && !!(i % 2)}
                />
              ))}
            </Box>
          </Box>
        </Box>
      </BackgroundImage>
    </div>
  )
}
